<template>
  <Transition name="slide-fade">
    <div class="bg-white p-5 pb-1 pt-4 mt-4 rounded">
      <StudentDetailHeader @back="handleBack" />
      
      <StudentInfoCard 
        :student="student"
        @edit="showEditModal = true"
        @delete="showDeleteModal = true"
      />

      <StudentRoutesSection 
        :routes="routes"
        :loading="loading"
      />

      <StudentBadgesSection 
        :badges="insignias"
        :loading="loading"
      />

      <ModalDeleteStudent
        v-if="showDeleteModal"
        :student="student"
        :url="url"
        @close="showDeleteModal = false"
        @success="handleBack"
      />

      <ModalEditStudent
        v-if="showEditModal"
        :student="student"
        :url="url"
        @close="showEditModal = false"
        @success="handleBack"
      />
    </div>
  </Transition>
</template>

<script>
import StudentDetailHeader from './components/StudentDetailHeader.vue'
import StudentInfoCard from './components/StudentInfoCard.vue'
import StudentRoutesSection from './components/StudentRoutesSection.vue'
import StudentBadgesSection from './components/StudentBadgesSection.vue'
import ModalDeleteStudent from './ModalDeleteStudent.vue'
import ModalEditStudent from './ModalEditStudent.vue'

export default {
  name: 'ShowStudent',
  
  components: {
    StudentDetailHeader,
    StudentInfoCard,
    StudentRoutesSection,
    StudentBadgesSection,
    ModalDeleteStudent,
    ModalEditStudent
  },

  props: {
    student: { type: Object, required: true },
    url: { type: String, required: true }
  },

  emits: ['changeVista'],

  data() {
    return {
      routes: [],
      insignias: [],
      loading: false,
      showDeleteModal: false,
      showEditModal: false
    }
  },

  computed: {
    apiUrl() {
      return `/dashboard/routesandinsignias/user/${this.student.id}`
    }
  },

  mounted() {
    this.loadStudentData()
  },

  methods: {
    async loadStudentData() {
      this.loading = true
      
      try {
        const response = await axios.get(this.apiUrl)
        this.routes = response.data.rutas || []
        this.insignias = response.data.insignias || []
      } catch (error) {
        console.error('Error loading student data:', error)
      } finally {
        this.loading = false
      }
    },

    handleBack() {
      this.$emit('changeVista', 'tabla')
    }
  }
}
</script>

<style scoped>
.slide-fade-enter-active {
  transition: all 0.3s ease-out;
}

.slide-fade-leave-active {
  transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
}

.slide-fade-enter-from,
.slide-fade-leave-to {
  transform: translateX(20px);
  opacity: 0;
}
</style>